<template>
  <md-card>
    <md-card-header>
      <md-avatar>
        <img
          class="item-photo"
          src="https://dummyimage.com/300x200/000/fff"
          alt="People"
        />
      </md-avatar>
      <h4>
        {{ value.first_name }}
      </h4>
    </md-card-header>
    <md-card-content>
      <p v-if="!editMode">
        {{ value.email }}
      </p>

      <div v-else class="outlined-field">
        <md-field>
          <label>Supervisor</label>
          <md-select v-model="value">
            <md-option
              v-for="user in catalogs.users"
              :key="user.id"
              :value="user.id"
            >
              {{ user.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      requried: true,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    catalogs: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  width: 360px;
  .md-card-header {
    display: flex;
    justify-items: start;
    align-items: center;
    height: 80px;
  }
}

.md-avatar {
  width: 60px;
  height: 60px;
  margin: 0;

  .item-photo {
    width: inherit;
    height: inherit;
    object-fit: cover;
  }
}
p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Divisions/StaffCard.vue